/**
 * Created by zhangxiaoqing on 2018/04/17.
 */
import * as types from "../mutation-types";
import userService from "@/api/userService.js";
import { Message } from "element-ui";
// import config from '@/assets/js/config.js'
// initial state
// shape: [{ id, quantity }]
const state = {
  websetList: window.sessionStorage.getItem("websetList") && JSON.parse(window.sessionStorage.getItem("websetList")),
  webset: window.sessionStorage.getItem("webset") && JSON.parse(window.sessionStorage.getItem("webset")) || {
    tenantId: window.localStorage.getItem('tenantId')
  },
  tenantId: window.localStorage.getItem("tenantId"),
  isOpenMobileEditor: false,
  tenantInfo: {}
};

// getters
const getters = {
  // 开启pc端
  isOpenPc() {
    let tenantInfo = state.tenantInfo;
    return tenantInfo && tenantInfo.status != 8;
  },

  // 开启移动端
  isOpenMobile() {
    let tenantInfo = state.tenantInfo;
    return tenantInfo && tenantInfo.mobileStatus != 8 && tenantInfo.status == 8;;
  }
};

// actions
const actions = {
  // 获取租户信息
  getTenantInfo({ state }) {
    userService
      .getResponse("getTenantInfoByTenantId", {
        id: state.tenantId
      })
      .then(res => {
        state.tenantInfo = res || {};
      })
      .catch(error => {
        console.error("获取租户信息" + error);
        //Message.error("获取租户信息" + error);
      });
  },

  // 获取移动端设置
  getMobileConfig({ state }) {
    userService
      .getResponse("getTenantConfigByKey", {
        key: "isOpenMobileText"
      })
      .then(res => {
        if (res && res.key == "isOpenMobileText") {
          state.isOpenMobileEditor = res.content == "1";
        }
      })
      .catch(error => {
        console.error("获取移动端设置" + error);
        //Message.error("获取移动端设置" + error);
      });
  }
};

// mutations
const mutations = {
  [types.SETTENANTID](state, webset) {
    state.webset = webset;
    webset
      ? window.sessionStorage.setItem("webset", JSON.stringify(webset))
      : window.sessionStorage.removeItem("webset");
  },
  [types.UPDATEWEBSITE](state, websetList) {
    state.websetList = websetList;
    websetList
      ? window.sessionStorage.setItem("websetList", JSON.stringify(websetList))
      : window.sessionStorage.removeItem("websetList");
  },
  [types.UPDATETENANTID](state, tenantId) {
    state.tenantId = tenantId;
    tenantId
      ? window.localStorage.setItem("tenantId", tenantId)
      : window.localStorage.removeItem("tenantId");
  },
  [types.UPDATEMOBILEEDITOR](state, isOpenMobileEditor) {
    state.isOpenMobileEditor = isOpenMobileEditor;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/webset.js